import { createStyles, makeStyles } from '@material-ui/core';
import { variables } from '../../../../styles';

export const useStyles = makeStyles(() =>
  createStyles({
    status: {
      height: 19,
      borderRadius: 4,
      paddingRight: 4,
      paddingLeft: 4,
      marginRight: 4,
      boxShadow: 'none',
      fontSize: 12,
      width: 'fit-content',
    },
    pending: {
      backgroundColor: variables.beige,
      color: variables.richBlack,
    },
    paid: {
      backgroundColor: variables.mediumSeaGreen,
      color: variables.white,
    },
    rejected: {
      backgroundColor: variables.americanPink,
      color: variables.white,
    },
    mixed: {
      backgroundColor: variables.black5,
      color: variables.richBlack,
    },
  }),
);
